import type { CapiNewsArticle } from 'types/capi/newsArticle';

export default function Title({ article }: { article: CapiNewsArticle }) {
  return (
    <h1 className="flex w-full text-2xl font-bold md:text-4xl">
      {article.title}
    </h1>
  );
}
